var qty = Math.floor(Math.random() * 5) + 1;
var scarcity = document.getElementById('scarcity');
if (scarcity) {
  var countDownDate = new Date();
  countDownDate.setMinutes(countDownDate.getMinutes() + 4);
  var x = setInterval(function () {
    var now = new Date().getTime();
    var distance = countDownDate - now;
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    var _seconds = seconds;
    if (seconds < 0) seconds = 0;
    if (minutes < 0) minutes = 0;
    if (seconds < 10) _seconds = '0' + seconds;
    scarcity.innerHTML = 'Your order is only reserved for <b>' + minutes + ':' + _seconds + ' minutes</b>!';
    if (distance <= 0) clearInterval(x);
  }, 1000);
}

// set display none for element when element with class cart__empty-text is visible
var cartEmpty = document.querySelector('.cart__empty-text');
if (cartEmpty) {
  var cartEmptyObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var scarcityElement = document.getElementById('sw-scarcity-elements');
      var discountElement = document.getElementById('SW_discount_text');
      
      if (entry.intersectionRatio > 0) {
        if (scarcityElement) scarcityElement.style.display = 'none';
        if (discountElement) discountElement.style.display = 'none';
      } else {
        if (scarcityElement) scarcityElement.style.display = 'block';
        if (discountElement) discountElement.style.display = 'block';
      }
    });
  });
  cartEmptyObserver.observe(cartEmpty);
}
